import { MenuItem } from "@mui/material";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type VerticalAlignFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const VerticalAlignField = (props: VerticalAlignFieldProps) => {
  return (
    <EditorVisualTextField
      select
      label="Vertical Align"
      size="small"
      fullWidth
      name={props.name}
      value={props.value}
      onChange={props.onChange}
    >
      <MenuItem value="top">Top</MenuItem>
      <MenuItem value="center">Center</MenuItem>
      <MenuItem value="bottom">Bottom</MenuItem>
    </EditorVisualTextField>
  );
};

export default VerticalAlignField;
